
















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import VueLib from 'vue';
import StyleSetting from './styleSetting/index.vue'
import DispalyRules from './dispalyRules.vue'
import PopSetting from './popSetting.vue'
import pluginDialog from "../components/pluginDialog.vue";
import {
  saveDraftDetailPopWindow,
  saveDetailPopWindow,
  getPopWindowTemplate,
  getPopWindowDetail,
  getPopWindowCopyDetail,
  getIsDeployJs,
  getQueryVariable
} from "@/services/api";
import { FormWheelOfFortuneSettingsVO, FormWheelSliceVO, PopSettingsVO, TFormSaveDetailRequest } from "@/model/FormWheel";
import store from "@/store";
import { DISABLE_CUSTOM_STEP_TPLID, isFullscreenPopupLayoutAllowed, isOnlyNewUserTemplate } from "@/utils/experiment";
import { normalizePopupLayoutRules } from "@/views/wheelOfFortune/utils/popupLayoutRules";
import { copyPageConfig } from "@/utils/copyPageConfig";
import { shortFormAddList } from "@/views/wheelOfFortune/constant/options";
import {
  getFormPageValues,
  getMiddlePageOrder,
  getMiddlePageValues,
  getNextFormPageValue,
  getPreviousFormPageValue,
  isMiddlePage
} from "./utils/stepPages";
import { syncExtendedCountdownFontToStyleMap } from "@/components/wheel/extendedCountdown/extendedCountdownModel";
import { isEnableCouponSize } from "@/utils/isEnableCouponSize";
import EventBus from '@/utils/eventBus';
import { applyCartRecommendDisplayDefaults, isCartRecommendSource } from '@/views/wheelOfFortune/utils/cartRecommendDefaults';
import { isFailMessage } from '@/i18n/failMessage';
import { localizeFormTemplateName } from '@/i18n/recommendCopy';

enum permissionType { EDIT = 'edit', CHECK = 'check' }

interface PageSetting {
  value: string;
  label: string;
  opacity: number;
  deletable?: boolean;
}

@Component({
  components: {
    "style-setting": StyleSetting,
    "dispaly-rules": DispalyRules,
    "pop-setting": PopSetting,
    pluginDialog
  },
})
export default class wheelOfFortunePop extends Vue {
  // 数据
  formData: TFormSaveDetailRequest<PopSettingsVO> = {
    name: "",
    type: "POP_WINDOW",
    expand: true,
    templateId: 2,

    settings: {
      typesetting: {
        imgUrl: '',
        imgHide: false,
        imgPosition: 'none',
        bgbox: false,
        bgboxColor: '#FFFFFF',
        // bgboxBorderRadius: '0',
        ...(this.enableCustomStep ? {
          middleBgboxColor: '#FFFFFF',
          endBgboxColor: '#FFFFFF',
        } : {})
      },
      logo: {
        imgUrl: '',
        imgHide: false
      },
      position: {
        position: 'LeftTop',
        backgroundColor: "#fff",
        iconUrl: "",
        iconSizeType: 'Medium',
        iconShow: true,
        iconTiming: 'after',
      },
      styles: {
        styleMap: {
          'cartx-b-show': {
            'background': '#ffffff',
            'font-family': 'Arial, sans-serif',
            "color": "#0F1222",
          },
          'cartx-b-title': {
            "color": "#C30D23",
            'font-family': 'Arial, sans-serif'
          },
          'cartx-b-title-end': {
            "color": "#C30D23",
            'font-family': 'Arial, sans-serif'
          },
          'cartx-b-subtitle': {
            "color": "#0F1222",
            'font-family': 'Arial, sans-serif'
          },
          'cartx-b-subtitle-end': {
            "color": "#0F1222",
            'font-family': 'Arial, sans-serif'
          },
          'cartx-b-button': {
            "color": "#FFFFFF",
            'font-family': 'Arial, sans-serif',
            'background': '#C30D23',
            'border-style': 'none',
            'border-radius': '4px',
            'border-color': '#C30D23'
          },
          'cartx-b-button-end': {
            "color": "#FFFFFF",
            'font-family': 'Arial, sans-serif',
            'background': '#C30D23',
            'border-style': 'none',
            'border-radius': '4px',
            'border-color': '#C30D23'
          },
          'cartx-b-show .cartx-b-button-end': {
            'background': ''
          },
          'cartx-b-show .cartx-b-button': {
            'background': ''
          },
          'cartx-b-thanks': {
            "color": "#0F1222",
            'font-family': 'Arial, sans-serif',
          },
          'cartx-b-thanks-end': {
            "color": "#0F1222",
            'font-family': 'Arial, sans-serif',
          },
          'cartx-b-time-item': {
            "background": "#5F0D20",
            'font-family': 'Arial, sans-serif',
            'border-radius': '4px',
          },
          'cartx-b-show .cartx-b-complete-1': {
            background: '',
          },
          'cartx-b-show .cartx-b-complete-2': {
            background: '',
          },
          'cartx-b-complete-1': {
            'border-radius': '4px',
            color: '#0F1222'
          },
          'cartx-b-complete-text-1': {
            'border-radius': '4px'
          },
          'cartx-b-complete-2': {
            'border-color': '#A1A0AA',
            background: '#FFFFFF',
            'border-radius': '1000px',
            color: '#A1A0AA'
          },
          'cartx-b-wheel-container': {
            'border-radius': '',
          },
          'cartx-b-input': {
            'font-family': 'Arial, sans-serif',
          },
          "cartx-b-privacy": {
            "font-family": "Arial, sans-serif",
            "font-size": "12px",
            "color": "",
            "background-color": "rgba(216, 216, 216, 0.35)",
            "margin-top": 0,
            "margin-bottom": 6,
            "margin-left": 0,
            "margin-right": 0,
          },
          "cartx-b-privacy-check": {
            "color": ""
          },
          ...(this.enableCustomStep ? {
            'cartx-b-wheel-container__middle': {},
            'cartx-b-title__middle': {},
            'cartx-b-subtitle__middle': {},
            'cartx-b-activity__middle': {},
            'cartx-b-input__middle': {
              'font-family': 'Arial, sans-serif',
            },
            'cartx-b-privacy__middle': {},
            'cartx-b-privacy-check__middle': {},
            'cartx-b-show__cover': {
              'background': '#ffffff'
            },
            'cartx-b-show__middle': {
              'background': '#ffffff',
              'font-family': 'Arial, sans-serif',
              "color": "#0F1222",
            },
            'cartx-b-button__middle': {},
            'cartx-b-show__middle .cartx-b-button__middle': {},
            'cartx-b-thanks__middle': {},
          } : {})
        },
      },
      targeting: {
        urls: [],
        urlParts: [],
        excludeUrls: [],
        excludeUrlParts: [],
        pages: [],
        excludePages: [],
        // 生效类型：0-始终生效，1-自定义时间
        type: 0,
      },

      texts: {},

      cover: {
        coverJumpType: 'click',
      },

      rules: {
        couponCodeType: '1',
        optionColumns: 1,
        inputType: 'all',
        optionColor: '#1D2129',
        optionTitleColor: '#1D2129',
        optionTextColor: '#1D2129',
        optionFontFamily: 'Arial, sans-serif',
        optionTitleFontSize: '16px',
        optionFontSize: '14px',
        optionBackground: '#1D2129',
        dropdownTitleColor: '#1D2129',
        dropdownTitleFontSize: '16px',
        dropdownTitleFontFamily: 'Arial, sans-serif',
        dropdownBorderStyle: 'solid',
        dropdownBorderColor: '#C5C4CE',
        dropdownBorderRadius: '4px',
        dropdownBackgroundType: '',
        dropdownBackgroundColor: '#FFFFFF',
        dropdownOptionTextColor: '#1d2129',
        inputBorderStyle: 'solid',
        inputBorderColor: '#C5C4C3',
        inputBorderRadius: '4px',
        inputBackground: '#FFFFFF',
        inputBackgroundShow: '',
        inputColor: '#1d2129',
        inputFontFamily: 'Arial, sans-serif',
        stepDisplay: false,
        terminalType:'',
        popupLayoutMode: 'standard' as 'standard' | 'fullscreen',
        skipWheelAnimationOnClose: false,
      },
    },
  };

  // 页面权限控制
  public permission = '';
  public permissionType = permissionType;
  // 激活的标签
  public activeTag = 'first';

  public templateName = '';

  //发布、保存提交防止反复提交标记
  public repeatSave = false

  public targetScript = '';
  public customTargetScript = '';

  public isEnablePopupCover = false;

  // 激活的标签
  public pageSettings: Array<PageSetting> = [
    { value: 'start', label: this.$tx('form.edit.step.start', '开始'), opacity: 1 },
    { value: 'end', label: this.$tx('form.completed', '结束'), opacity: 1 },
    { value: 'packUp', label: this.$tx('form.edit.step.packUp', '收起'), opacity: 1 }
  ]

  /** 折扣列表中是否包含有效的自定义优惠券（couponId + reserveCode 均非空） */
  get hasCustomerDiscountInList() {
    return (this.formData.settings.discountList || []).some(
      (item: any) => item.discount?.couponId && item.discount.couponId.startsWith('CUST_')
        && item.discount?.reserveCode
    );
  }

  get customFormPages() {
    return getFormPageValues(this.pageSettings || []);
  }

  get customMiddlePages() {
    return getMiddlePageValues(this.pageSettings || []);
  }

  // SKA2792: 阶梯折扣固定模板(templateId=210)
  get isTieredDiscountTemplate() {
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return templateId === '210';
  }

  getCustomStepFormEntries(settings: any) {
    const middlePages = this.customMiddlePages.filter((page: string) => {
      return !(this.isTieredDiscountTemplate && page === 'middle');
    });
    const pageValues = this.isTieredDiscountTemplate
      ? ['start', ...middlePages]
      : ['start', ...middlePages, 'end'];
    return pageValues.flatMap((page: string) => {
      return (((settings as any)?.[page] || []) as any[]).map((field: any) => ({ page, field }));
    });
  }

  validateTieredDiscountStepThreeRequired() {
    if (!this.isTieredDiscountTemplate) {
      return true;
    }
    const stepThreeList = (((this.formData.settings as any) || {}).middle2 || []) as any[];
    const hasRequiredField = stepThreeList.some((item: any) => item?.necessary === true);
    if (!hasRequiredField) {
      this.activePageSetting = 'middle2';
      this.activeTag = 'first';
      this.$message.error(this.$tx('form.edit.err.needRequiredStep3', '步骤三请至少保留一个必填采集项'));
      return false;
    }
    return true;
  }

  get isEditAbTest() {
    return getQueryVariable('abtest') === 'true' && getQueryVariable('edit') === 'true';
  }

  get isAbTest() {
    return getQueryVariable('abtest') === 'true';
  }

  get currentAbtestIndex() {
    return parseInt(getQueryVariable('idx'));
  }

  get enableOnlyNewUserCustomStep() {
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return isOnlyNewUserTemplate(templateId);
  }

  get enableCustomStep() {
    if ([3, 5, 6].includes(this.formData?.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  get enablePopSetting() {
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return this.formData.triggerEventType === 0 &&
      !['19', '20','40', '41'].includes(templateId);
  }

  jumpToList() {
    this.$router.push('/wheel_of_fortune/list');
  }

  backToAbtest() {
    this.$router.push(`/wheel_of_fortune/abtest/${getQueryVariable('abtestid')}`)
  }

  needInstallPlugin = false;
  plugInDialogShow = false;
  isShopify = false;

  public checkPluginInstall() {
    this.plugInDialogShow = false;
    getIsDeployJs({}, false).then((res) => {
      if (res?.data?.data?.integrationType == 1) {
        this.isShopify = true;
        sessionStorage.setItem('isShopify', '1');
        sessionStorage.setItem('integrationId', '1');
      } else {
        sessionStorage.setItem('isShopify', '0');
      }
      if (res?.data?.data?.integrationType == 1 || res?.data?.data?.integrationType == 11) {
        this.needInstallPlugin = !res?.data?.data?.deployJs;
      }
    });
  }
  public showPlugInDialog() {
    this.plugInDialogShow = true;
  }
  public closePluginDialog() {
    this.needInstallPlugin = false;
    this.plugInDialogShow = false;
    this.save();
  }
  public onlyClosePluginDialog() {
    this.plugInDialogShow = false;
  }

  async created(): Promise<void> {
    if (this.$route.params.id) {
      this.getPopWindowDetail()
    } else if (this.$route.params.copyId) {
      this.getPopWindowCopyDetail()
    } else {
      this.getPopWindowTemplate()
    }
    this.checkPluginInstall();
  }

  mounted() {
    // 监听窗口大小变化，重新定位 Popover reference
    window.addEventListener('resize', this.positionPopoverReference);
    EventBus.$on('end-button-redirect-enable-request', this.handleEndButtonRedirectEnableRequest);
    // this.checkShowDeviceSettingDialog();
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.positionPopoverReference);
    EventBus.$off('end-button-redirect-enable-request', this.handleEndButtonRedirectEnableRequest);
  }

  handleEndButtonRedirectEnableRequest(request: any) {
    const settings = this.formData.settings as any;
    const formPages = getFormPageValues(this.pageSettings || []).filter((page: string) => page !== 'end');
    for (const page of formPages) {
      const conflictQuestion = ((settings[page] || []) as any[]).find((field: any) =>
        field !== request.question && field.endButtonRedirectEnabled === true
      );
      if (conflictQuestion) {
        request.allowed = false;
        request.conflictLabel = conflictQuestion.question || conflictQuestion.label || '';
        return;
      }
    }
  }

  // 检查是否需要显示设备设置提示 Popover
  checkShowDeviceSettingDialog() {
    // const hasRead = localStorage.getItem('device-setting-read');
    // if (!hasRead) {
    //   this.$nextTick(() => {
    //     this.positionPopoverReference();
    //     setTimeout(() => {
    //       const popover = this.$refs.deviceSettingPopover as any;
    //       if (popover && popover.doShow) {
    //         popover.doShow();
    //       }
    //     }, 100);
    //   });
    // }
  }

  /**
   * formData 异步回填后同步一次子组件（styleSetting）的默认预览设备：
   * 刮刮乐（SCRATCH_CARD_TPLID）默认移动端。styleSetting 的 created 先于接口数据执行，
   * 只能覆盖 URL 带 templateid 的场景，故数据到位后需再补一次。方法幂等，可重复调用。
   */
  syncScratchCardDevice() {
    // Vue2 中父组件 data 变化后，子组件 props 要等父组件 re-render 的 patch 阶段
    // （prepatch -> updateChildComponent）才真正更新；同步调用会读到旧 props（templateId=2）。
    // 放到 $nextTick，等 props 下发完成后再触发子组件判断。
    this.$nextTick(() => {
      const setting = this.$refs.styleSetting as any;
      if (setting && typeof setting.syncScratchDefaultDevice === 'function') {
        setting.syncScratchDefaultDevice();
      }
    });
  }

  // 定位 Popover reference 到"展示规则"标签位置
  positionPopoverReference() {
    const tabs = this.$el.querySelector('.el-tabs') as HTMLElement;
    if (tabs) {
      const tabItems = tabs.querySelectorAll('.el-tabs__item');
      const displayRulesTab = (tabs.querySelector('#tab-second') ||
        Array.from(tabItems).find((item: Element) => {
          const text = item.textContent?.trim();
          return text === '展示规则' || text === this.$tx('form.edit.tab.rules', '展示规则');
        })) as HTMLElement;

      if (displayRulesTab && this.$refs.displayRulesTabRef) {
        const ref = this.$refs.displayRulesTabRef as HTMLElement;
        const rect = displayRulesTab.getBoundingClientRect();
        const tabsRect = tabs.getBoundingClientRect();

        ref.style.position = 'fixed';
        ref.style.top = `${rect.bottom}px`;
        ref.style.left = `${rect.left + rect.width / 2}px`;
        ref.style.width = '1px';
        ref.style.height = '1px';
      }
    }
  }

  // 确认设备设置提示
  handleConfirmDeviceSetting() {
    localStorage.setItem('device-setting-read', 'true');
    const popover = this.$refs.deviceSettingPopover as any;
    if (popover && popover.doClose) {
      popover.doClose();
    }
  }

  initSetting(data: TFormSaveDetailRequest<PopSettingsVO>): TFormSaveDetailRequest<PopSettingsVO> {
    if (data.settings.styles) {
      data.settings.styles.styleMap = {
        ...this.formData.settings.styles?.styleMap,
        ...data.settings.styles.styleMap,
      };
      delete (data.settings.styles.styleMap as any)['cartx-b-form-style-cache'];
    } else {
      data.settings.styles = this.formData.settings.styles?.styleMap;
    }
    data.settings.typesetting = data.settings.typesetting || this.formData.settings.typesetting;
    data.settings.logo = data.settings.logo || this.formData.settings.logo;
    data.settings.rules = {
      ...this.formData.settings.rules,
      ...data.settings.rules
    }
    // 兼容错误数据并修改cartx-b-button-end => cartx-b-button-end
    for (let key of Object.keys(data.settings.styles?.styleMap || {})) {
      const matchRes = key.match(/^[a-zA-Z\-.]*\.(cartx-b-[a-zA-Z\-]*-end)$/);
      if (matchRes && data.settings.styles?.styleMap) {
        data.settings.styles.styleMap[matchRes[1]] = data.settings.styles.styleMap[key];
        delete data.settings.styles.styleMap[key]
      }
    }

    // 隐私政策文字颜色默认使用选项颜色
    if (data.settings.styles?.styleMap?.['cartx-b-privacy']) {
      if (
        !data.settings.styles.styleMap['cartx-b-privacy']['color'] &&
        data.settings.rules?.optionColor
      ) {
        console.log('change data.settings.styles.styleMap.cartx-b-privacy.color', data.settings.rules.optionColor);
        data.settings.styles.styleMap['cartx-b-privacy']['color'] = data.settings.rules.optionColor;
      }
      if (
        !data.settings.styles.styleMap['cartx-b-privacy-check']['color'] &&
        data.settings.rules?.optionBackground
      ) {
        console.log('change data.settings.styles.styleMap.cartx-b-privacy-check.color', data.settings.rules?.optionBackground);
        data.settings.styles.styleMap['cartx-b-privacy-check']['color'] = data.settings.rules?.optionBackground;
      }
      console.log(data.settings.styles.styleMap['cartx-b-privacy']);
      if (data.settings.styles.styleMap['cartx-b-privacy']['padding-top'] === undefined) {
        data.settings.styles.styleMap['cartx-b-privacy']['padding-top'] = 4;
      }
      if (data.settings.styles.styleMap['cartx-b-privacy']['padding-bottom'] === undefined) {
        data.settings.styles.styleMap['cartx-b-privacy']['padding-bottom'] = 4;
      }
      if (data.settings.styles.styleMap['cartx-b-privacy']['padding-left'] === undefined) {
        data.settings.styles.styleMap['cartx-b-privacy']['padding-left'] = 8;
      }
      if (data.settings.styles.styleMap['cartx-b-privacy']['padding-right'] === undefined) {
        data.settings.styles.styleMap['cartx-b-privacy']['padding-right'] = 8;
      }
      if (!data.settings.rules?.privacyPosition) {
        data.settings.rules.privacyPosition = 'form';
        if (data.triggerEventType === 7) {
          data.settings.styles.styleMap['cartx-b-privacy']['margin-top'] = 6;
          data.settings.styles.styleMap['cartx-b-privacy']['margin-bottom'] = 0;
        } else {
          data.settings.styles.styleMap['cartx-b-privacy']['margin-top'] = 0;
          data.settings.styles.styleMap['cartx-b-privacy']['margin-bottom'] = 6;
        }
      }
    }

    if (!data.settings.rules.terminalType) {
      data.settings.rules.terminalType = 'all'
    }

    if (!data.settings.rules.popupLayoutMode) {
      data.settings.rules.popupLayoutMode = 'standard';
    }
    const templateId = String(data?.templateId ?? this.$route.query.templateid ?? '');
    if (!isFullscreenPopupLayoutAllowed(templateId, data?.triggerEventType)) {
      data.settings.rules.popupLayoutMode = 'standard';
    }
    // popWindowWheel=3 默认强制全屏页（且在样式设置中不可切回标准弹窗）；trigger=7 除外
    const disallowFullscreenForWheel3 = Number(data?.triggerEventType) === 7;
    if (Number(data?.popWindowWheel) === 3 && !disallowFullscreenForWheel3) {
      data.settings.rules.popupLayoutMode = 'fullscreen';
    }
    normalizePopupLayoutRules(data);
    const styleMap: any = data.settings.styles?.styleMap;
    if (styleMap) {
      if (!styleMap['cartx-b-input']) {
        VueLib.set(styleMap, 'cartx-b-input', {});
      }
      if (!styleMap['cartx-b-input']['font-family']) {
        VueLib.set(styleMap['cartx-b-input'], 'font-family', 'Arial, sans-serif');
      }
      Object.keys(styleMap)
        .filter((key) => key.startsWith('cartx-b-input__'))
        .forEach((key) => {
          if (!styleMap[key]['font-family']) {
            VueLib.set(styleMap[key], 'font-family', 'Arial, sans-serif');
          }
        });
    }

    // 选项/下拉菜单样式拆分兼容：历史 optionColor 同步到拆分后的标题、选项和下拉菜单颜色。
    const rules: any = data.settings.rules;
    if (rules.optionColor && !rules.optionTitleColor) {
      VueLib.set(rules, 'optionTitleColor', rules.optionColor);
    }
    if (rules.optionColor && !rules.optionTextColor) {
      VueLib.set(rules, 'optionTextColor', rules.optionColor);
    }
    if (!rules.optionFontFamily) {
      VueLib.set(rules, 'optionFontFamily', 'Arial, sans-serif');
    }
    if (!rules.middleOptionFontFamily) {
      VueLib.set(rules, 'middleOptionFontFamily', 'Arial, sans-serif');
    }
    if (rules.optionColor && !rules.dropdownTitleColor) {
      VueLib.set(rules, 'dropdownTitleColor', rules.optionColor);
    }
    if (rules.optionColor && !rules.dropdownOptionTextColor) {
      VueLib.set(rules, 'dropdownOptionTextColor', rules.optionColor);
    }
    if (rules.middleOptionColor && !rules.middleOptionTitleColor) {
      VueLib.set(rules, 'middleOptionTitleColor', rules.middleOptionColor);
    }
    if (rules.middleOptionColor && !rules.middleOptionTextColor) {
      VueLib.set(rules, 'middleOptionTextColor', rules.middleOptionColor);
    }
    if (rules.middleOptionColor && !rules.middleDropdownTitleColor) {
      VueLib.set(rules, 'middleDropdownTitleColor', rules.middleOptionColor);
    }
    if (rules.middleOptionColor && !rules.middleDropdownOptionTextColor) {
      VueLib.set(rules, 'middleDropdownOptionTextColor', rules.middleOptionColor);
    }
    if (typeof rules.optionTitleFontSize === 'undefined') {
      VueLib.set(rules, 'optionTitleFontSize', '16px');
    }
    if (typeof rules.optionFontSize === 'undefined') {
      VueLib.set(rules, 'optionFontSize', '14px');
    }
    if (typeof rules.dropdownTitleFontSize === 'undefined') {
      VueLib.set(rules, 'dropdownTitleFontSize', '16px');
    }
    if (!rules.dropdownTitleFontFamily) {
      VueLib.set(rules, 'dropdownTitleFontFamily', 'Arial, sans-serif');
    }
    if (typeof rules.dropdownBorderStyle === 'undefined') {
      VueLib.set(rules, 'dropdownBorderStyle', 'solid');
    }
    if (typeof rules.dropdownBorderColor === 'undefined') {
      VueLib.set(rules, 'dropdownBorderColor', '#C5C4CE');
    }
    if (typeof rules.dropdownBorderRadius === 'undefined') {
      VueLib.set(rules, 'dropdownBorderRadius', '4px');
    }
    if (typeof rules.dropdownBackgroundType === 'undefined') {
      VueLib.set(rules, 'dropdownBackgroundType', '');
    }
    if (typeof rules.dropdownBackgroundColor === 'undefined') {
      VueLib.set(rules, 'dropdownBackgroundColor', '#FFFFFF');
    }

    // 与 C 端一致：展示倒计时仅由 rules.countDownShow 控制；存量无该字段时按 rules.countDown 推断
    if (data.settings.rules.countDownShow === undefined) {
      const countDownSec = Number(data.settings.rules.countDown);
      VueLib.set(
        data.settings.rules,
        'countDownShow',
        !Number.isNaN(countDownSec) && countDownSec > 0
      );
    }

    // 开始页配置统一使用 textStartNew，补齐 new 组件依赖的基础字段
    if (!data.settings.rules?.closeButtonConfig && data.settings.rules?.closeColor) {
      VueLib.set(data.settings.rules, 'closeButtonConfig', {
        position: 'right-top',
        bgMode: 'none',
        bgColor: 'rgba(0,0,0,0)',
        iconColor: data.settings.rules.closeColor,
        size: '18px',
      });
    }
    if (typeof data.settings.rules?.mobilePictureShow === 'undefined') {
      VueLib.set(data.settings.rules, 'mobilePictureShow', false);
    }
    if (typeof data.settings.rules?.skipWheelAnimationOnClose === 'undefined') {
      VueLib.set(data.settings.rules, 'skipWheelAnimationOnClose', false);
    }
    if (!data.settings.rules?.mobileRatio) {
      VueLib.set(data.settings.rules, 'mobileRatio', 'recommendRatio');
    }
    if (!data.settings.authList) {
      VueLib.set(data.settings, 'authList', []);
    }
    if (data.settings.typesetting?.wheelPosition === undefined) {
      VueLib.set(data.settings.typesetting, 'wheelPosition', 'top');
    }
    if (data.settings.typesetting?.wheelImgUrl === undefined) {
      VueLib.set(data.settings.typesetting, 'wheelImgUrl', data.settings.typesetting?.bgImgUrl);
    }
    if (data.settings.typesetting?.pointImgPosition === undefined) {
      VueLib.set(data.settings.typesetting, 'pointImgPosition', 'middle');
    }

    // 结束页配置统一使用 textEndNew，单步骤存量数据也需要补齐结束页独立字段
    if (data.settings.typesetting?.endBgbox === undefined) {
      VueLib.set(data.settings.typesetting, 'endBgbox', data.settings.typesetting?.bgbox);
    }
    if (data.settings.typesetting?.endBgboxColor === undefined) {
      VueLib.set(data.settings.typesetting, 'endBgboxColor', data.settings.typesetting?.bgboxColor);
    }
    if (data.settings.typesetting?.endImgPosition === undefined) {
      VueLib.set(data.settings.typesetting, 'endImgPosition', data.settings.typesetting?.imgPosition);
    }
    if (data.settings.typesetting?.imgUrlEnd === undefined) {
      VueLib.set(data.settings.typesetting, 'imgUrlEnd', data.settings.typesetting?.imgUrl);
    }
    if (data.settings.rules?.endCountDownShow === undefined) {
      VueLib.set(data.settings.rules, 'endCountDownShow', data.settings.rules.countDownShow ?? false);
    }
    if (typeof data.settings.rules?.endMobilePictureShow === 'undefined') {
      VueLib.set(data.settings.rules, 'endMobilePictureShow', Boolean(data.settings.rules?.mobilePictureShow));
    }
    if (!data.settings.rules?.endMobileRatio) {
      VueLib.set(data.settings.rules, 'endMobileRatio', 'recommendRatio');
    }
    if (data.settings.rules?.endCloseColor === undefined) {
      VueLib.set(data.settings.rules, 'endCloseColor', data.settings.rules.closeColor ?? '#463C32');
    }
    if (!data.settings.rules?.endCloseButtonConfig && data.settings.rules?.endCloseColor) {
      VueLib.set(data.settings.rules, 'endCloseButtonConfig', {
        position: 'right-top',
        bgMode: 'none',
        bgColor: 'rgba(0,0,0,0)',
        iconColor: data.settings.rules.endCloseColor,
        size: '18px',
      });
    }
    if (data.settings.typesetting?.endBgImgUrl === undefined) {
      VueLib.set(data.settings.typesetting, 'endBgImgUrl', data.settings.typesetting?.bgImgUrl);
    }
    if (data.settings.styles.styleMap['cartx-b-show__end'] === undefined) {
      data.settings.styles.styleMap['cartx-b-show__end'] = {
        ...data.settings.styles.styleMap['cartx-b-show']
      };
    }
    if (data.settings.styles.styleMap['cartx-b-wheel-container__end'] === undefined) {
      data.settings.styles.styleMap['cartx-b-wheel-container__end'] = {
        ...data.settings.styles.styleMap['cartx-b-wheel-container']
      }
    }

    // 分步骤初始化页签
    if (this.enableCustomStep) {
      // 存量分步骤兼容
      if (data.settings.rules.stepDisplay) {

      }

      if (data.settings.rules?.middleCountDownShow === undefined) {
        VueLib.set(data.settings.rules, 'middleCountDownShow', data.settings.rules.countDownShow ?? false);
      }

      // 关闭按钮高级设置兼容性处理：将老的 closeColor 迁移到新的 closeButtonConfig
      // 中间页
      if (!data.settings.rules?.middleCloseButtonConfig && data.settings.rules?.middleCloseColor) {
        VueLib.set(data.settings.rules, 'middleCloseButtonConfig', {
          position: 'right-top',
          bgMode: 'none',
          bgColor: 'rgba(0,0,0,0)',
          iconColor: data.settings.rules.middleCloseColor,
          size: '18px',
        });
      }
      console.log('initSetting styleMap', data.settings.styles.styleMap);

      const incomingPageSettings = Array.isArray((data.settings as any)?.pageSettings)
        ? (data.settings as any).pageSettings
        : [];
      const settingsMiddlePages = Object.keys((data.settings as any) || {}).filter((key: string) => {
        if (!isMiddlePage(key)) {
          return false;
        }
        const list = (data.settings as any)?.[key];
        return Array.isArray(list) && list.length > 0;
      });
      const incomingMiddlePages = incomingPageSettings
        .map((item: any) => item?.value)
        .filter((value: string) => isMiddlePage(value));
      const existingMiddlePages = Array.from(new Set([...settingsMiddlePages, ...incomingMiddlePages]))
        .sort((a: string, b: string) => getMiddlePageOrder(a) - getMiddlePageOrder(b));
      // SKA2792: 210 阶梯折扣固定模板——强制四步骤
      const isTieredDiscountTemplate = `${Number((this as any).$route?.query?.templateid) || Number(getQueryVariable('templateid')) || data.templateId}` === '210';
      if (isTieredDiscountTemplate) {
        const cloneDefaultField = (type: string) => {
          const item = (shortFormAddList as any[]).find((field: any) => field.type === type);
          return item ? JSON.parse(JSON.stringify(item)) : null;
        };
        ['middle', 'middle2'].forEach((value) => {
          if (!existingMiddlePages.includes(value)) {
            existingMiddlePages.push(value);
          }
          if (!Array.isArray((data.settings as any)[value])) {
            VueLib.set(data.settings as any, value, []);
          }
        });
        VueLib.set(data.settings as any, 'middle', []);
        if (!Array.isArray(data.settings.start)) {
          VueLib.set(data.settings as any, 'start', []);
        }
        if (data.settings.start.length === 0) {
          const emailField = cloneDefaultField('Email');
          if (emailField) {
            VueLib.set(data.settings as any, 'start', [emailField]);
          }
        }
        if ((data.settings as any).middle2.length === 0) {
          const mobileField = cloneDefaultField('Mobile Number');
          if (mobileField) {
            VueLib.set(data.settings as any, 'middle2', [mobileField]);
          }
        }
        const hasMiddleScopedConfig = !!(
          data.settings.texts?.middleMainButton ||
          data.settings.styles?.styleMap?.['cartx-b-button__middle'] ||
          data.settings.styles?.styleMap?.['cartx-b-show__middle .cartx-b-button__middle']
        );
        if (!hasMiddleScopedConfig) {
          copyPageConfig(data.settings, 'startToMiddle');
        }
        VueLib.set(data.settings as any, 'middle', []);
        existingMiddlePages.sort((a: string, b: string) => getMiddlePageOrder(a) - getMiddlePageOrder(b));
        VueLib.set(data.settings.rules, 'stepDisplay', true);
        VueLib.set(data.settings.rules, 'buttonAction', 'open');
        VueLib.set(data.settings.rules, 'middleButtonAction', 'open');
        VueLib.set(data.settings.rules, 'middle2ButtonAction', 'open');
      }
      // 嵌入式表单最多2步（1个中间页），存量数据超过的裁剪掉
      if (data.triggerEventType === 7 && existingMiddlePages.length > 1) {
        existingMiddlePages.splice(1);
      }
      if (!isTieredDiscountTemplate && data.settings.rules?.stepDisplay === true && existingMiddlePages.length === 0) {
        copyPageConfig(data.settings, 'startToMiddle');
        existingMiddlePages.push('middle');
      }
      const hasMiddleFromIncomingPageSettings = incomingPageSettings.some((item: any) => isMiddlePage(item?.value));
      const shouldUseStepPages =
        data.settings.rules.stepDisplay ||
        existingMiddlePages.length > 0 ||
        hasMiddleFromIncomingPageSettings;

      if (isTieredDiscountTemplate) {
        this.pageSettings = [
          { value: 'start', label: this.$tx('form.edit.step.form1', '表单步骤一'), opacity: 1, deletable: false },
          { value: 'middle', label: this.$tx('form.edit.step.form2', '表单步骤二'), opacity: 1, deletable: false },
          { value: 'middle2', label: '表单步骤三', opacity: 1, deletable: false },
          { value: 'end', label: this.$tx('form.completed', '结束'), opacity: 1, deletable: false },
          { value: 'packUp', label: this.$tx('form.edit.step.packUp', '收起'), opacity: 1 }
        ];
        VueLib.set(data.settings as any, 'pageSettings', this.pageSettings);
        this.activePageSetting = 'start';
        this.activeTag = 'first';
      } else if (shouldUseStepPages) {
        this.pageSettings = [
          { value: 'start', label: this.$tx('form.edit.step.form1', '表单步骤一'), opacity: 1, deletable: true },
          ...existingMiddlePages.map((value: string, index: number) => ({
            value,
            label: `表单步骤${index + 2}`,
            opacity: 1,
            deletable: true
          })),
          { value: 'end', label: this.$tx('form.completed', '结束'), opacity: existingMiddlePages.length > 0 && data.settings.rules.middleButtonAction === 'open' ? 1 : 0 },
          { value: 'packUp', label: this.$tx('form.edit.step.packUp', '收起'), opacity: 1 }
        ];
        // 后端如果传了 pageSettings，优先覆写对应页签文案/透明度/删除能力
        if (incomingPageSettings.length > 0) {
          this.pageSettings = this.pageSettings.map((item: any) => {
            const incomingItem = incomingPageSettings.find((p: any) => p?.value === item.value);
            return incomingItem ? { ...item, ...incomingItem } : item;
          });
        }
        this.activePageSetting = 'start';
        this.activeTag = 'first';
      } else {
        this.pageSettings = [
          { value: 'start', label: this.$tx('form.edit.step.form', '表单'), opacity: 1 },
          { value: 'end', label: this.$tx('form.completed', '结束'), opacity: data.settings.rules.buttonAction === 'open' ? 1 : 0 },
          { value: 'packUp', label: this.$tx('form.edit.step.packUp', '收起'), opacity: 1 }
        ];
        if (incomingPageSettings.length > 0) {
          this.pageSettings = this.pageSettings.map((item: any) => {
            const incomingItem = incomingPageSettings.find((p: any) => p?.value === item.value);
            return incomingItem ? { ...item, ...incomingItem } : item;
          });
        }
        this.activePageSetting = 'start';
        this.activeTag = 'first';
      }

      console.log('initSetting change', data.settings);
    }

    //初始化标签
    //弃单挽留弹框
    if (data.triggerEventType == 5) {
      this.pageSettings[1].opacity = 0.3
      // https://u60z777w08.feishu.cn/docx/BfE5dvNA9omAQPx5j7vcxlMtnTc 弃单可以打开收起页，内部横幅隐藏
      // this.pageSettings[2].opacity = 0.3
    }

    //邮件/短信承接弹窗
    if (data.triggerEventType == 3) {
      this.pageSettings[1].opacity = 0.3
    }

    //退出意图挽留弹窗
    if (data.triggerEventType == 1) {
      if (data.settings.styleType == 'Coupon') {
        this.pageSettings[1].opacity = 0.3
      }
    }

    // 嵌入弹窗，收起页不显示
    if (data.triggerEventType == 7) {
      const pickUpPageSetting = this.pageSettings.find(item => item.value === 'packUp');
      if (pickUpPageSetting) {
        pickUpPageSetting.opacity = 0.3;
      }
    }

    // 如果不是true，显式设置为false
    if (data?.settings?.typesetting && data?.settings?.typesetting?.bgbox === undefined) {
      data.settings.typesetting.bgbox = false;
      data.settings.typesetting.bgboxColor = '#FFFFFF';
      // data.settings.typesetting.bgboxBorderRadius = '0';
    }

    // 开启封面
    if (data.popWindowWheel !== 1 && data.coverDisplay === 1) {
      this.isEnablePopupCover = true;
      this.pageSettings = [
        {
          value: 'cover',
          label: this.$tx('form.edit.step.cover', '封面'),
          opacity: 1,
          ...(this.enableCustomStep ? { deletable: true } : {})
        },
        ...this.pageSettings
      ];

      if (this.enableCustomStep) {
        // 在数据初始化时使用 Vue.set 确保 cover 对象是响应式的
        if (!data.settings.cover) {
          VueLib.set(data.settings, 'cover', {
            coverJumpType: 'click',
            bgCoverImgUrl: undefined,
            closeColor: data.settings.rules.closeColor as string,
          });
        } else {
          VueLib.set(data.settings.cover, 'closeColor', data.settings.rules.closeColor as string);
        }
        // 在数据初始化时使用 Vue.set 确保 styleMap['cartx-b-show__cover'] 是响应式的
        VueLib.set(data.settings.styles.styleMap, 'cartx-b-show__cover', {
          'background': data.settings.styles.styleMap['cartx-b-show'].background as string,
        });
      }

      this.activePageSetting = 'cover';
      this.activeTag = 'first';
    }
    console.log('initSetting after', this.formData.settings, this.pageSettings, this.activePageSetting, this.activeTag);

    return data;
  }

  async getPopWindowDetail() {
    try {
      let { data, status } = await getPopWindowDetail({ id: this.$route.params.id }, true);
      if (status == 200) {
        this.formData = this.initSetting(data.data);
        this.checkShowDeviceSettingDialog();
        this.syncScratchCardDevice();
        sessionStorage.setItem('popType', data.data.type);
      }
    } catch (e) {
      console.error('getPopWindowDetail error', e);
      if (String(e)?.indexOf('ID对应的数据不存在') > -1) {
        window.location.replace(process.env.VUE_APP_DOMAIN + '/cartsee-new/dashboard')
      }
    }
  }

  async getPopWindowCopyDetail() {
    let { data, status } = await getPopWindowCopyDetail({ id: this.$route.params.copyId }, true)
    if (status == 200) {
      this.formData = this.initSetting(data.data);
      this.checkShowDeviceSettingDialog();
      this.syncScratchCardDevice();
    }
  }

  async getPopWindowTemplate() {
    let { data, status } = await getPopWindowTemplate({ id: this.$route.query.templateid }, true)
    if (status == 200) {
      this.templateName = JSON.parse(JSON.stringify(data.data)).name
      this.formData = this.initSetting(data.data);
      if (isCartRecommendSource(this.$route.query.source as string)) {
        applyCartRecommendDisplayDefaults(this.formData);
      }
      this.checkShowDeviceSettingDialog();
      this.syncScratchCardDevice();
      this.generalFormNameRandomSuffix();
      this.formData.id = ''
      sessionStorage.setItem('popType', data.data.type)
    }
  }

  generalFormNameRandomSuffix() {
    let code = '';
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const pos = chars.length;
    for (let i = 0; i < 6; i++) {
      const idx = Math.floor(Math.random() * pos);
      code += chars.charAt(idx);
    }
    this.formData.name = localizeFormTemplateName(this.formData.name) + code;
  }

  activePageSetting = this.pageSettings[0].value;

  changeActivePageSetting(value: string) {
    const buttonAction = this.formData.settings.rules.middleButtonAction || this.formData.settings.rules.buttonAction;
    if (buttonAction == 'open' && value == 'end') {
      this.activePageSetting = value
    } else if (value == 'end') {
      this.$message.warning(this.$tx('form.edit.err.noEndForOpen', '按钮点击非"打开弹窗结果"此时无结束页面'))
      return
    }
    this.activePageSetting = value
    return
  }

  changeRules(val:any){
    // 保留现有规则字段，避免子组件回传局部 rules 时覆盖丢失 popupLayoutMode 等关键参数
    this.formData.settings.rules = {
      ...(this.formData.settings.rules || {}),
      ...(val || {})
    };
  }
  changeTargetingData(val: any) {
    this.formData.settings.targeting = val
  }

  changeformData(val: any) {
    this.formData = val;
    ((this.$refs.styleSetting as Vue).$refs.popExhibition as Vue).$forceUpdate();
  }
  public tableData: FormWheelSliceVO[] = []


  /**
   * 下一步
   */
  nextStep() {
    console.log('nextStep', this.activeTag, this.activePageSetting);
    switch (this.activeTag) {
      case 'first':
        switch (this.activePageSetting) {
          case 'cover':
            if (this.formData.settings.cover?.bgCoverImgUrl) {
              this.activePageSetting = 'start';
              this.activeTag = 'first';
            } else {
              this.$message.warning(this.$tx('form.edit.err.coverRequired', '该模版封面图片不可为空，请修改！'))
            }
            break;
          case 'start':
            if (!this.validateSmsSubscriptionRules({ checkTerminalType: false })) {
              return;
            }
            if (this.SettingValid()) {
              if (this.formData.triggerEventType == 3 || (this.formData.triggerEventType == 1 && this.formData.settings.styleType == 'Coupon')) {
                //邮件/短信承接弹窗、离开订阅弹框中的优惠券模版
                this.activePageSetting = 'packUp';
              } if (this.formData.triggerEventType == 5) {
                //弃单挽留弹框
                this.activeTag = 'second';
              } else {
                if (this.formData.settings.rules.buttonAction == 'open') {
                  const nextFormPage = getNextFormPageValue(this.pageSettings, 'start');
                  if (nextFormPage) {
                    this.activePageSetting = nextFormPage;
                  } else {
                    this.activePageSetting = 'end';
                  }
                } else {
                  if (this.formData.triggerEventType == 7) {
                    this.activeTag = 'second';
                  } else {
                    this.activePageSetting = 'packUp';
                  }
                }
              }
            }
            break;
          case 'end':
            if (this.formData.triggerEventType == 7) {
              this.activeTag = 'second';
            } else if (this.packUpValid()) {
              this.activePageSetting = 'packUp';
            }
            break;
          case 'packUp':
            if (this.sendValid()) {
              this.activeTag = 'second';
            }
            break;
          default:
            if (isMiddlePage(this.activePageSetting)) {
              if (!this.validateSmsSubscriptionRules({ checkTerminalType: false })) {
                return;
              }
              const nextFormPage = getNextFormPageValue(this.pageSettings, this.activePageSetting);
              if (this.formData.settings.rules.middleButtonAction == 'open') {
                this.activePageSetting = nextFormPage || 'end';
              } else if (this.formData.triggerEventType == 7) {
                this.activeTag = 'second';
              } else {
                this.activePageSetting = 'packUp';
              }
            }
            break;
        }
        break;
      case 'second':
        if (!this.validateSmsSubscriptionRules({ checkTerminalType: true })) {
          return;
        }
        this.activeTag = 'third';
        break;
      default:
        break;
    }
  }

  /**
   * 上一步
   */
  backStep() {
    console.log('backStep', this.activeTag, this.activePageSetting);
    switch (this.activeTag) {
      case 'first':
        switch (this.activePageSetting) {
          case 'start':
            // 包含弹窗封面
            if (this.formData.settings.cover) {
              this.activePageSetting = 'cover';
            } else {
              this.$router.push('/wheel_of_fortune/list');
            }
            break;
          case 'end':
            if (this.customMiddlePages.length > 0) {
              this.activePageSetting = this.customMiddlePages[this.customMiddlePages.length - 1];
            } else {
              this.activePageSetting = 'start'
            }
            break;
          case 'packUp':
            if (this.customMiddlePages.length > 0) {
              if (this.formData.settings.rules.middleButtonAction == 'open') {
                this.activePageSetting = 'end';
              } else {
                this.activePageSetting = this.customMiddlePages[this.customMiddlePages.length - 1];
              }
            } else {
              if (this.formData.settings.rules.buttonAction == 'open') {
                this.activePageSetting = 'end';
              } else {
                this.activePageSetting = 'start';
              }
            }
            break;
          default:
            if (isMiddlePage(this.activePageSetting)) {
              this.activePageSetting = getPreviousFormPageValue(this.pageSettings, this.activePageSetting) || 'start';
            }
            break;
        }
        break;
      case 'second':
        if (this.formData.triggerEventType == 7) {
          if (this.formData.settings.rules.middleButtonAction === 'open') {
            this.activePageSetting = 'end';
          } else if (this.formData.settings.rules.buttonAction === 'open') {
            this.activePageSetting = this.customMiddlePages[0] || 'start';
          } else {
            this.activePageSetting = 'start';
          }
        } else {
          this.activePageSetting = 'packUp'
        }
        this.activeTag = 'first';
        break;
      case 'third':
        this.activeTag = 'second';
        break;
      default:
        break;
    }
  }

  showCancelDialog = false;
  /**
   * 取消
   */
  cancel() {
    switch (this.activeTag) {
      case 'first':
        switch (this.activePageSetting) {
          case 'cover':
            this.showCancelDialog = true;
            break;
          case 'start':
            // this.$router.push('/wheel_of_fortune/list');
            this.showCancelDialog = true;
            break;
          case 'end':
            this.activePageSetting = 'start'
            break;
          case 'packUp':
            if (this.formData.settings.rules.buttonAction == 'open') {
              this.activePageSetting = 'end';
            } else {
              this.activePageSetting = 'start';
            }
            break;
          default:
            break;
        }
        break;
      case 'second':
        this.activePageSetting = 'packUp'
        this.activeTag = 'first';
        break;
      case 'third':
        this.activeTag = 'second';
        break;
      default:
        break;
    }
  }

  confirmCancel() {
    this.showCancelDialog = false;
    if (this.isAbTest) {
      if (this.isEditAbTest) {
        this.$router.push(`/wheel_of_fortune/abtest/${getQueryVariable('abtestid')}`)
      } else {
        window.close();
      }
    } else {
      this.$router.push('/wheel_of_fortune/list');
    }
  }

  /**
   * 设置校验
   */
  clearSmsSubBodyError() {
    const smsInputs = this.$el.querySelectorAll('.sms-sub-body-input');
    smsInputs.forEach((el: Element) => {
      (el as HTMLElement).classList.remove('is-error');
    });
  }

  focusSmsSubBody(page: string) {
    this.activeTag = 'first';
    this.activePageSetting = page;
    this.$nextTick(() => {
      const textStartRef: any = this.$refs.styleSetting?.$refs?.textExhibition?.$refs?.textStart;
      const smsSubBodyRef: any = textStartRef?.$refs?.smsSubBody;
      const smsSubBodyEl = smsSubBodyRef?.$el as HTMLElement | undefined;
      if (smsSubBodyEl) {
        smsSubBodyEl.classList.add('is-error');
        const textareaEl = smsSubBodyEl.querySelector('textarea') as HTMLTextAreaElement | null;
        textareaEl?.focus();
      }
    });
  }

  validateSmsSubscriptionRules(options: { checkTerminalType?: boolean } = {}) {
    const { checkTerminalType = true } = options;
    this.clearSmsSubBodyError();
    const startForms: any[] = (this.formData.settings.start || []) as any[];
    const middleForms: any[] = this.customMiddlePages.flatMap((page: string) => ((this.formData.settings as any)?.[page] || []) as any[]);
    const firstMiddlePage = this.customMiddlePages[0] || 'middle';
    const hasMiddlePage = this.customMiddlePages.length > 0;
    const terminalType = this.formData.settings.rules.terminalType;
    const isMobileField = (item: any) => (item?.type || '').toString().trim().toLowerCase() === 'mobile number';
    const isSmartCollect = (item: any) => (item?.collectWay || '').toString().trim().toLowerCase() === 'smart';

    const startSmsEnabled = this.formData.settings.rules.buttonAction === 'sms';
    const middleSmsEnabled = this.formData.settings.rules.middleButtonAction === 'sms';
    const hasSmsEnabled = startSmsEnabled || middleSmsEnabled;

    const startSmartEnabled = startForms.some(item => isMobileField(item) && isSmartCollect(item));
    const middleSmartEnabled = middleForms.some(item => isMobileField(item) && isSmartCollect(item));

    const startHasOtherFields = startForms.some(item => !isMobileField(item));
    const middleHasOtherFields = middleForms.some(item => !isMobileField(item));

    if (hasMiddlePage && startSmsEnabled) {
      this.activeTag = 'first';
      this.activePageSetting = 'start';
      this.$message.error(this.$tx('form.edit.err.smsNotStep1', '“通过短信订阅”不支持在表单步骤一设置，请检查后重试。'));
      return false;
    }

    if (startSmsEnabled !== startSmartEnabled) {
      this.activeTag = 'first';
      this.activePageSetting = 'start';
      this.$message.error(this.$tx('form.edit.err.smsNeedSmart', '“通过短信订阅”按钮与“快捷采集”手机号采集项需同时启用，请检查后重试。'));
      return false;
    }

    if (hasMiddlePage && middleSmsEnabled !== middleSmartEnabled) {
      this.activeTag = 'first';
      this.activePageSetting = firstMiddlePage;
      this.$message.error(this.$tx('form.edit.err.smsNeedSmart', '“通过短信订阅”按钮与“快捷采集”手机号采集项需同时启用，请检查后重试。'));
      return false;
    }

    if (startSmsEnabled && startHasOtherFields) {
      this.activeTag = 'first';
      this.activePageSetting = 'start';
      this.$message.error(this.$tx('form.edit.err.smsPhoneOnly', '“通过短信订阅”仅支持与手机号采集同步骤，请移除其他采集项。'));
      return false;
    }

    if (hasMiddlePage && middleSmsEnabled && middleHasOtherFields) {
      this.activeTag = 'first';
      this.activePageSetting = firstMiddlePage;
      this.$message.error(this.$tx('form.edit.err.smsPhoneOnly', '“通过短信订阅”仅支持与手机号采集同步骤，请移除其他采集项。'));
      return false;
    }

    if (hasSmsEnabled && (!this.formData.settings.rules.smsSubBody || !this.formData.settings.rules.smsSubBody.trim())) {
      const page = middleSmsEnabled ? firstMiddlePage : 'start';
      this.focusSmsSubBody(page);
      this.$message.error(this.$tx('form.edit.err.smsEmpty', '短信订阅信息为空，请完善'));
      return false;
    }

    if (checkTerminalType && hasSmsEnabled && terminalType !== 'mobile') {
      // 展示设备配置在“展示规则”页，命中该校验时应停留在展示规则
      this.activeTag = 'second';
      this.$message.error(this.$tx('form.edit.err.smsMobileOnly', '通过短信订阅仅支持移动端应用'));
      return false;
    }

    return true;
  }

  hasSmsSubscriptionEnabled() {
    return this.formData.settings.rules.buttonAction === 'sms' || this.formData.settings.rules.middleButtonAction === 'sms';
  }

  blockName(index: number) {
    return this.$tx('form.edit.field.blockN', '块{{n}}', { n: index + 1 });
  }

  enumJoin(items: string[]) {
    const sep = this.$tx('common.enumJoin', '、');
    return items.join(sep === '、' ? '、' : `${sep} `);
  }

  SettingValid() {
    if (!this.validateSmsSubscriptionRules({ checkTerminalType: false })) {
      return false;
    }
    // SKA2792: 210 模板校验步骤三必填
    if (!this.validateTieredDiscountStepThreeRequired()) {
      return false;
    }
    // 嵌入式表单：表单至少保留 1 个采集字段（允许删光邮箱/手机只留自定义问题，但不能一个字段都不留）
    if (this.formData.triggerEventType === 7) {
      const startFields = this.formData.settings.start || [];
      if (!startFields.length) {
        this.activePageSetting = 'start';
        this.activeTag = 'first';
        this.$message.warning(this.$tx('form.edit.err.needOneField', '表单至少需要保留 1 个采集字段'));
        return false;
      }
    }
    // 背景图片校验
    if (this.formData.settings?.typesetting?.imgPosition && this.formData.settings.typesetting.imgPosition !== 'none' && !this.formData.settings?.typesetting?.imgUrl) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.edit.err.needImageOrNone', '请上传图片或选择无图样式'));
      return false;
    }
    //弹窗校验
    if (!this.formData.name) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.edit.err.nameEmpty', '弹窗名称不能为空'))
      this.$nextTick(() => {
        const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelName
        wheelNameEl.focus();
      })
      return false;
    }
    //倒计时校验
    if (isNaN(this.formData.settings.rules.countDown) &&
      this.formData.settings.rules.countDownShow) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.edit.err.countdownEmpty', '倒计时不能为空'))
      this.$nextTick(() => {
        const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.countDown
        wheelNameEl.focus();
      })
      return false;
    }

    //主按钮校验
    if (!this.formData?.settings?.texts?.mainButton) {
      this.activePageSetting = 'start'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.edit.err.btnTextEmpty', '主按钮文字不能为空'))
      this.$nextTick(() => {
        const spinButtonEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.mainButton;
        spinButtonEl.focus();
      })
      return false;
    }

    //邮箱校验
    if (this.formData.settings.rules.emailOpen && !this.formData.settings.rules.emailTip && this.formData.settings.rules.emailPosition == 'start') {
      this.activePageSetting = 'start'
      this.activeTag = "first";
      this.$message.warning(this.$tx('form.edit.err.emailEmpty', '邮箱不能为空'))
      this.$nextTick(() => {
        const emailTipEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.emailTip
        emailTipEl.focus();
      })
      return false;
    }

    // Coupon校验
    if (
      this.formData.settings.rules.couponCodeShow &&
      !(
        !!this.formData.settings.rules.couponCode ||
        !!this.formData.settings.discount ||
        !!this.formData.settings.discountList ||
        !!this.formData.settings.rules.multipleDiscountShow ||
        this.hasCustomerDiscountInList
      ) &&
      this.formData.settings.rules.couponCodePosition == 'start'
    ) {
      this.activePageSetting = 'start'
      this.activeTag = "first";
      this.$message.warning(this.$tx('form.edit.err.couponEmpty', 'Coupon不能为空'))
      this.$nextTick(() => {
        const emailTipEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.Coupon
        emailTipEl.focus();
      })
      return false;
    }

    // 多折扣券包校验
    if (this.formData.settings.rules.multipleDiscountShow) {
      const multipleDiscountList = this.formData.settings.multipleDiscountList;
      if (!multipleDiscountList || multipleDiscountList.length === 0) {
        this.activePageSetting = 'end'
        this.activeTag = "first";
        this.$message.warning(this.$tx('form.edit.err.multiCouponEmpty', '多折扣券包列表不能为空'))
        return false;
      }

      // 校验列表中的任一coupon不能为空
      const hasEmptyCoupon = multipleDiscountList.some(item => {
        // 固定折扣码需要检查couponCode
        return !item.couponCode || item.couponCode.trim() === '';
      });

      if (hasEmptyCoupon) {
        this.activePageSetting = 'end'
        this.activeTag = "first";
        this.$message.warning(this.$tx('form.edit.err.couponEmpty', 'Coupon不能为空'))
        return false;
      }
    }

    console.log('校验动态折扣表单')
    if (this.formData.settings.discountList) {
      // 概率不为0的固定折扣码不能为空
      let blocks: Record<string, boolean> = {};
      let errors: Record<string, boolean> = {}
      for (let i = 0; i < this.formData.settings.discountList.length; i++) {
        const item = this.formData.settings.discountList[i];
        let block = this.blockName(i);
        if (item.deg === undefined) {
          blocks[block] = true;
          errors[this.$tx('form.pointerDirection', '指针指向')] = true;
        }
        if (item.rate === undefined) {
          blocks[block] = true;
          errors[this.$tx('form.probability2', '概率')] = true;
        }
        if (item.discountType === 1 && item.rate && item.rate > 0 && !item.coupon) {
          blocks[block] = true;
          errors[this.$tx('brand.monitor.couponCode', '折扣码')] = true;
        }
        if (item.discountType === 2 && !item.discount) {
          blocks[block] = true;
          errors[this.$tx('form.edit.field.uniqueCoupon', '动态折扣码')] = true;
        }
      }
      console.log('校验动态折扣表单: ', blocks, errors);
      if (Object.keys(blocks).length > 0) {
        this.$message.warning(this.$tx('form.edit.err.fillBlocks', '请填写 {{blocks}}的{{fields}}', { blocks: this.enumJoin(Object.keys(blocks)), fields: this.enumJoin(Object.keys(errors)) }));
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelOptionsCollapse;
          wheelNameEl && wheelNameEl.focus();
        })
        return false;
      }

      // 校验折扣码概率相加100
      const totalRate = this.formData.settings.discountList.reduce((a, i) => a += i.rate || 0, 0);
      console.log('校验动态折扣表单 totalRate', totalRate);
      // 使用parseFloat和toFixed解决浮点数精度问题
      if (parseFloat(totalRate.toFixed(2)) !== 100) {
        this.$message.warning(this.$tx('form.edit.err.probSum100', '折扣码概率相加必须等于100'));
        // 如果概率相加不等于100，自动跳转
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelOptionsCollapse;
          wheelNameEl && wheelNameEl.focus();
        })
        return false;
      }
    }

    //按钮连接校验
    if (this.formData.settings.rules.buttonAction == 'link' && !this.formData.settings.rules.openUrl) {
      this.activePageSetting = 'start'
      this.activeTag = "first";
      this.$message.warning(this.$tx('form.edit.err.btnLinkEmpty', '按钮连接不能为空'))
      this.$nextTick(() => {
        const linkEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.link
        linkEl.focus();
      })
      return false;
    }

    // 距离底部校验
    if (
      this.formData.settings.position?.iconCustom &&
      (this.formData.settings.position?.iconCustomBottom === undefined || typeof +this.formData.settings.position?.iconCustomBottom !== 'number' || isNaN(+this.formData.settings.position?.iconCustomBottom))
    ) {
      this.activePageSetting = 'packUp'
      this.activeTag = "first";
      this.$message.warning(this.$tx('form.edit.err.marginEmpty', '自定义边距值不可为空'))
      this.$nextTick(() => {
        const emailTipEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.iconCustomBottom
        emailTipEl.focus();
      })
      return false;
    }

    // 第三方登录 Client ID 校验
    if (this.formData.settings?.authList && this.formData.settings.authList.length > 0) {
      for (const auth of this.formData.settings.authList) {
        if (!auth.clientId || auth.clientId.trim() === '') {
          this.activePageSetting = 'start';
          this.activeTag = "first";
          // 查找对应的第三方登录提供商名称
          const authProviders = [
            { type: 2, name: 'Google' }
          ];
          const providerName = authProviders.find(p => p.type === auth.type)?.name || this.$tx('form.socialLogin', '第三方登录');
          this.$message.error(this.$tx('form.edit.err.needClientId', '请填写 {{name}} 的 Client ID（客户端ID）', { name: providerName }));
          return false;
        }
      }
    }

    return true;
  }
  packUpValid() {

    //主按钮校验
    if (!this.formData?.settings?.texts?.endMainButton) {
      this.activePageSetting = 'end'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.edit.err.btnTextEmpty', '主按钮文字不能为空'))
      this.$nextTick(() => {
        const spinButtonEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textEnd.$refs.mainButton;
        spinButtonEl.focus();
      })
      return false;
    }

    //复制按钮文本校验
    if (!this.formData?.couponCopyText) {
      this.activePageSetting = 'end'
      this.activeTag = 'first';
      this.$message.warning(this.$tx('form.edit.err.copyBtnEmpty', '复制按钮文本不能为空'))
      this.$nextTick(() => {
        const spinButtonEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textEnd.$refs.couponCopyTextButton;
        spinButtonEl.focus();
      })
      return false;
    }

    //邮箱校验
    if (this.formData.settings.rules.emailOpen && !this.formData.settings.rules.emailTip && this.formData.settings.rules.emailPosition == 'end') {
      this.activePageSetting = 'end'
      this.activeTag = "first";
      this.$message.warning(this.$tx('form.edit.err.emailEmpty', '邮箱不能为空'))
      this.$nextTick(() => {
        const emailTipEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textEnd.$refs.emailTip
        emailTipEl.focus();
      })
      return false;
    }

    // 是否显示结果页
    const { buttonAction, middleButtonAction } = this.formData.settings.rules;
    const hideEndPage = (buttonAction && buttonAction !== 'open') || (middleButtonAction && middleButtonAction !== 'open');
    console.log('hideEndPage', { hideEndPage, buttonAction, middleButtonAction });
    // Coupon校验
    if (
      this.formData.settings.rules.couponCodeShow &&
      !(
        !!this.formData.settings.rules.couponCode ||
        !!this.formData.settings.discount ||
        !!this.formData.settings.discountList ||
        !!this.formData.settings.rules.multipleDiscountShow ||
        this.hasCustomerDiscountInList
      ) &&
      this.formData.settings.rules.couponCodePosition == 'end' &&
      !hideEndPage
    ) {
      this.activePageSetting = 'end'
      this.activeTag = "first";
      this.$message.warning(this.$tx('form.edit.err.couponEmpty', 'Coupon不能为空'))
      this.$nextTick(() => {
        const emailTipEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textEnd.$refs.Coupon
        emailTipEl.focus();
      })
      return false;
    }

    // 多折扣券包校验
    if (this.formData.settings.rules.multipleDiscountShow) {
      const multipleDiscountList = this.formData.settings.multipleDiscountList;
      if (!multipleDiscountList || multipleDiscountList.length === 0) {
        this.activePageSetting = 'end'
        this.activeTag = "first";
        this.$message.warning(this.$tx('form.edit.err.multiCouponEmpty', '多折扣券包列表不能为空'))
        return false;
      }

      // 校验列表中的任一coupon不能为空
      const hasEmptyCoupon = multipleDiscountList.some(item => {
        // 固定折扣码需要检查couponCode
        return !item.couponCode || item.couponCode.trim() === '';
      });

      if (hasEmptyCoupon) {
        this.activePageSetting = 'end'
        this.activeTag = "first";
        this.$message.warning(this.$tx('form.edit.err.couponEmpty', 'Coupon不能为空'))
        return false;
      }
    }

    //按钮连接校验
    if (this.formData.settings.rules.endButtonAction == 'link' && !this.formData.settings.rules.endOpenUrl) {
      this.activePageSetting = 'end'
      this.activeTag = "first";
      this.$message.warning(this.$tx('form.edit.err.btnLinkEmpty', '按钮连接不能为空'))
      this.$nextTick(() => {
        const linkEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textEnd.$refs.link
        linkEl.focus();
      })
      return false;
    }
    if (!this.validateEndButtonAnswerRedirect()) {
      return false;
    }
    return true;
  }

  validateEndButtonAnswerRedirect() {
    if (Number(this.formData.triggerEventType) === 7) {
      return true;
    }
    // 无论结束页按钮当前是关闭还是跳转，分流配置本身都必须保持唯一且合法；close 只代表运行时不生效。
    const settings = this.formData.settings as any;
    const formPages = getFormPageValues(this.pageSettings || []).filter((page: string) => page !== 'end');
    const enabledQuestions = formPages.flatMap((page: string) => (settings[page] || []) as any[])
      .filter((field: any) => field.endButtonRedirectEnabled === true);

    if (enabledQuestions.length === 0) {
      return true;
    }

    const showError = (message: string) => {
      this.activePageSetting = 'end';
      this.activeTag = 'first';
      this.$message.warning(message);
      return false;
    };

    if (enabledQuestions.length > 1) {
      return showError(this.$tx('form.edit.err.redirectOneSingle', '按答案跳转只能选择一道单选题'));
    }

    const question = enabledQuestions[0];
    if (question.type !== '自定义' || question.questionType !== 'Single') {
      return showError(this.$tx('form.edit.err.redirectCustomOnly', '按答案跳转仅支持自定义单选题，请重新选择'));
    }

    const options = Array.isArray(question.optionList) ? question.optionList : [];
    const redirectUrls = options
      .map((option: any) => (option.endButtonRedirectUrl || '').trim())
      .filter(Boolean);
    if (redirectUrls.length === 0) {
      return showError(this.$tx('form.edit.err.needRedirectOption', '请至少配置一个选项跳转链接'));
    }

    const hasInvalidUrl = redirectUrls.some((url: string) => {
      try {
        const parsedUrl = new URL(url);
        return !['http:', 'https:'].includes(parsedUrl.protocol) || !parsedUrl.hostname;
      } catch (error) {
        return true;
      }
    });
    if (hasInvalidUrl) {
      return showError(this.$tx('form.set.err.redirectHttp', '选项跳转链接需填写完整的 http:// 或 https:// 地址'));
    }
    return true;
  }

  sendValid() {
    if (
      this.formData.settings.position?.iconCustom &&
      (this.formData.settings.position?.iconCustomBottom === undefined || typeof +this.formData.settings.position?.iconCustomBottom !== 'number' || isNaN(+this.formData.settings.position?.iconCustomBottom))
    ) {
      this.$message.warning(this.$tx('form.edit.err.marginEmpty', '自定义边距值不可为空'))
      return false
    }
    return true
  }

  showSaveDraftDialog = false;
  confirmSaveDraft() {
    this.showSaveDraftDialog = true;
  }

  showEmbeddedScriptDialog = false;
  confirmEmbeddedScript(formData: any) {
    this.targetScript = `<div id="cartx-form-${formData.id}"></div>`
    this.showEmbeddedScriptDialog = true;
  }

  showCustomTargetScriptDialog = false;
  confirmCustomTargetScript(formData: any) {
    this.customTargetScript = `window.cartsee = window.cartsee || [];\n window.cartsee.push(['openForm', '${formData.id}']);`
    this.showCustomTargetScriptDialog = true;
  }

  copyCode() {
    const code = (document.getElementById('dispaly-rules-form-code') as HTMLTextAreaElement).value;
    navigator.clipboard.writeText(code);
    this.$message.success(this.$tx('common.success.copy', '复制成功'));
  }

  handleEmbeddedScriptDialogClose() {
    this.showEmbeddedScriptDialog = false;
    this.$router.push('/wheel_of_fortune/list');
  }

  handleEmbeddedScriptDialogCopy() {
    this.copyCode();
    this.handleEmbeddedScriptDialogClose();
  }

  copyCustomTargetScriptCode() {
    const code = (document.getElementById('dispaly-rules-form-custom-code') as HTMLTextAreaElement).value;
    navigator.clipboard.writeText(code);
    this.$message.success(this.$tx('common.success.copy', '复制成功'));
  }

  handleCustomTargetScriptDialogClose() {
    this.showCustomTargetScriptDialog = false;
    this.$router.push('/wheel_of_fortune/list');
  }

  handleCustomTargetScriptDialogCopy() {
    this.copyCustomTargetScriptCode();
    this.handleCustomTargetScriptDialogClose();
  }

  formattingData(data: any) {
    if (data.length == 0) {
      return []
    }
    for (let i = 0; i < data.length; i++) {
      if (data[i].type === "Mobile Number" && typeof data[i].text === "string") {
        if (!data[i].text.endsWith(" ")) {
          data[i].text += " ";
        }
      }
    }
    return data
  }

  /**
   * 刮刮乐配置校验（保存 / 保存草稿时调用）。
   *
   * 当前 MVP 阶段不做奖项名称 / 折扣码的独立校验：
   * FormScratchCardSettingsVO 只有 position / coatImage / awardBgImage / bgColor /
   * text / fontFamily / color / fontSize，既没有 awardName 也没有 couponCode 字段，
   * B 端也不提供对应配置项，在此校验只会恒定拦截、导致无法保存。
   * 奖项文案走 scratchCard.text，折扣码走 settings.rules.couponCode，
   * 后者已由 SettingValid() 按 couponCodeShow 统一校验，这里不重复拦截。
   * 后续若新增奖项名称配置，在此补充对应校验即可。
   */
  scratchValid() {
    return true;
  }

  /**
   * 保存草稿
   */
  saveDraft() {
    if (this.templateName) {
      window.gtag('event', 'subscribe-tool_create_draft', {
        event_name:'订阅工具保存为草稿',
        event_type:'按钮点击',
        event_des:'订阅工具保存为草稿',
        subscribe_type:this.templateName,
        Company_id:JSON.parse(localStorage.getItem('companyInfo'))?.id,
        os_type:JSON.parse(localStorage.getItem('osInfo'))?.os,
        os_version:JSON.parse(localStorage.getItem('osInfo'))?.version,
        browser_type:JSON.parse(localStorage.getItem('browserInfo'))?.browser,
        browser_version:JSON.parse(localStorage.getItem('browserInfo'))?.version,
        conutry:localStorage.getItem('countryName'),
        time:new Date()
      });
    }
    this.showSaveDraftDialog = false;

    // 每次保存草稿时校验广告图
    if (this.formData && ['35', '49'].includes(`${this.formData.templateId}`)) {
      const settings = this.formData.settings;
      const hasLeftAdImage = !!settings?.typesetting?.leftAdImage;
      const hasRightAdImage = !!settings?.typesetting?.rightAdImage;
      const hasMiddleLeftAdImage = !!settings?.typesetting?.middleLeftAdImage;
      const hasMiddleRightAdImage = !!settings?.typesetting?.middleRightAdImage;
      if (hasLeftAdImage !== hasRightAdImage || hasMiddleLeftAdImage !== hasMiddleRightAdImage) {
        this.$message({
          message: this.$tx('form.bothAdImagesThisTemplate', '该模版广告图需同时配置2张（不可只配置其中1张）'),
          type: 'error'
        });
        return false;
      }
    }
    if (this.repeatSave) {
      return
    }
    this.repeatSave = true

    if (!this.validateSmsSubscriptionRules({ checkTerminalType: true }) || !this.SettingValid() || !this.packUpValid() || !this.scratchValid()) {
      this.repeatSave = false
      return;
    }

    // 校验所有页面表单不能有重复项
    const pageSettings = this.formData.settings.pageSettings;
    if (pageSettings) {
      const pageSettingsValues = pageSettings.map(item => item.value);
      const uniquePageSettingsValues = [...new Set(pageSettingsValues)];
      if (pageSettingsValues.length !== uniquePageSettingsValues.length) {
        this.$message.warning(this.$tx('form.edit.err.dupAllPages', '所有页面表单不能有重复项'));
        this.repeatSave = false;
        return false;
      }

      // 校验步骤间采集项不能重复
      const attributeSet = new Set<string>();
      const settings = this.formData.settings;
      const allFormList = [
        ...(settings.start || []),
        ...this.customMiddlePages.flatMap((page: string) => ((settings as any)?.[page] || []) as any[]),
        ...(settings.end || [])
      ];
      // 检查是否有重复采集的属性
      for (const field of allFormList) {
        const attribute = field.attribute || field.type || '';
        if (field.type === 'Mobile Number' && (!field.privacyPolicyLink || field.privacyPolicyLink === '')) {
          this.$message.error(this.$tx('form.edit.err.smsPrivacyEmpty', '短信隐私政策链接为空，请完善'));
          this.repeatSave = false;
          return false;
        }
        if (attribute && attribute.trim() !== '') {
          if (attributeSet.has(attribute)) {
            const label = field.label || field.type || attribute;
            this.$message.warning(this.$tx('form.edit.err.dupAttr', '{{label}}属性重复采集', { label }));
            this.repeatSave = false;
            return false;
          }
          attributeSet.add(attribute);
        }
      }

      // 增加pageSetting
      this.formData.settings.pageSettings = this.pageSettings;
      this.formData.settings.rules.stepDisplay = this.customMiddlePages.some(
        (page: string) => (((this.formData.settings as any)?.[page] || []) as any[]).length > 0
      );
    }

    // 校验步骤间采集项不能重复
    const attributeSet = new Set<string>();
    const settings = this.formData.settings;
    const allFormList = [
      ...(settings.start || []),
      ...(settings.middle || []),
      ...(settings.end || [])
    ];
    console.log('allFormList', allFormList);
    // 检查是否有重复采集的属性
    for (const field of allFormList) {
      const attribute = field.attribute || field.type || '';
      if (field.type === 'Mobile Number' && (!field.privacyPolicyLink || field.privacyPolicyLink === '')) {
        this.$message.error(this.$tx('form.edit.err.smsPrivacyEmpty', '短信隐私政策链接为空，请完善'));
        this.repeatSave = false;
        return false;
      }
      if (attribute && attribute.trim() !== '') {
        if (attributeSet.has(attribute)) {
          const label = field.label || field.type || attribute;
          this.$message.warning(this.$tx('form.edit.err.dupAttr', '{{label}}属性重复采集', { label }));
          this.repeatSave = false;
          return false;
        }
        attributeSet.add(attribute);
      }
    }

    // 增加pageSetting
    this.formData.settings.pageSettings = this.pageSettings;
    this.formData.settings.rules.stepDisplay = this.customMiddlePages.some(
      (page: string) => (((this.formData.settings as any)?.[page] || []) as any[]).length > 0
    );

    if (this.$route.query.templateid) {
      this.formData.templateId = Number(this.$route.query.templateid) || 1;
    }
    this.ensurePopupLayoutModeForSubmit();
    const enableCouponSize = isEnableCouponSize(this.formData?.templateId);
    // popWindowWheel=2：确保多折扣券包的首个 couponCode 同步到 settings.rules.couponCode
    // 这样发布/保存时后端稳定读取到该字段
    if (Number(this.formData?.popWindowWheel) === 2) {
      const list = this.formData?.settings?.multipleDiscountList;
      const rules = this.formData?.settings?.rules;
      if (Array.isArray(list) && list.length > 0 && rules) {
        rules.couponCode = list[0]?.couponCode || '';
        if (enableCouponSize) {
          // 折扣值能力需要走公司灰度，并排除单步骤模板
          this.$set(rules, 'couponSize', list[0]?.couponSize || '');
        }
      }
    }
    if (!enableCouponSize) {
      // 非灰度或单步骤模板提交前清理折扣值，避免历史缓存或子组件数据带入新增字段
      delete (this.formData.settings.rules as { couponSize?: string }).couponSize;
      (this.formData.settings.multipleDiscountList || []).forEach((item: { couponSize?: string }) => delete item.couponSize);
      (this.formData.settings.discountList || []).forEach((item: { couponSize?: string }) => delete item.couponSize);
    }
    this.formData.settings.rules.openUrl = this.httpvoid(this.formData.settings.rules.openUrl)
    this.formData.settings.rules.endOpenUrl = this.httpvoid(this.formData.settings.rules.endOpenUrl)
    this.formData.settings.position.iconShow = Number(this.formData.settings.position.iconShow)
    this.formData.settings.start = this.formattingData(this.formData.settings.start)
    this.customMiddlePages.forEach((page: string) => {
      (this.formData.settings as any)[page] = this.formattingData((this.formData.settings as any)[page] || []);
    });

    syncExtendedCountdownFontToStyleMap(this.formData.settings);
    saveDraftDetailPopWindow(this.formData, true).then((res) => {
      this.$message({
        message: this.$tx('common.success.draft', '保存草稿成功'),
        center: true,
        type: 'success'
      });
      store.commit('DELETE_SUGGEST_MAP', 'form_ids');

      if (this.formData.triggerEventType === 7 && !this.formData.id) {
        this.confirmEmbeddedScript(res?.data?.data);
        return
      }

      if (this.formData.triggerEventType === 8 && !this.formData.id) {
        this.confirmCustomTargetScript(res?.data?.data);
        return;
      }

      if (this.isAbTest) {
        this.$router.push(`/wheel_of_fortune/abtest/${getQueryVariable('abtestid')}`)
      } else {
        this.$router.push('/wheel_of_fortune/list');
      }
    }).catch(error => {
      if (isFailMessage(error, '名称不能相同，请修改！')) {
        // 如果名称相同，自动跳转并修改
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelName
          wheelNameEl && wheelNameEl.focus();
        })
      }
      this.repeatSave = false
    });
  }
  //校验http
  httpvoid(val: string) {
    if (val.length == 0) {
      return ''
    }
    let newStr2 = val.indexOf("http://")
    if (newStr2 === -1) {
      let newStr2 = val.indexOf("https://")
      if (newStr2 === -1) {
        return 'http://' + val
      }
    }
    return val
  }

  /**
   * 发布
   */
  save() {
    if (this.templateName) {
      window.gtag('event', 'subscribe-tool_create_finish', {
        event_name: '订阅工具完成创建',
        event_type: '按钮点击',
        event_des: '订阅工具完成创建',
        subscribe_type: this.templateName,
        Company_id: JSON.parse(localStorage.getItem('companyInfo'))?.id,
        os_type: JSON.parse(localStorage.getItem('osInfo'))?.os,
        os_version: JSON.parse(localStorage.getItem('osInfo'))?.version,
        browser_type: JSON.parse(localStorage.getItem('browserInfo'))?.browser,
        browser_version: JSON.parse(localStorage.getItem('browserInfo'))?.version,
        conutry: localStorage.getItem('countryName'),
        time: new Date()
      });
    }
    if (this.needInstallPlugin) {
      this.showPlugInDialog();
      return;
    }
    if (this.repeatSave) {
      return
    }
    this.repeatSave = true

    if (!this.validateSmsSubscriptionRules({ checkTerminalType: true }) || !this.SettingValid() || !this.packUpValid() || !this.scratchValid()) {
      this.repeatSave = false
      return;
    }
    if (this.$route.query.templateid) {
      this.formData.templateId = Number(this.$route.query.templateid) || 1;
    }
    this.ensurePopupLayoutModeForSubmit();
    const enableCouponSize = isEnableCouponSize(this.formData?.templateId);
    // popWindowWheel=2：确保多折扣券包的首个 couponCode 同步到 settings.rules.couponCode
    // 这样发布/保存时后端稳定读取到该字段
    if (Number(this.formData?.popWindowWheel) === 2) {
      const list = this.formData?.settings?.multipleDiscountList;
      const rules = this.formData?.settings?.rules;
      if (Array.isArray(list) && list.length > 0 && rules) {
        rules.couponCode = list[0]?.couponCode || '';
        if (enableCouponSize) {
          // 折扣值能力需要走公司灰度，并排除单步骤模板
          this.$set(rules, 'couponSize', list[0]?.couponSize || '');
        }
      }
    }
    if (!enableCouponSize) {
      // 非灰度或单步骤模板提交前清理折扣值，避免历史缓存或子组件数据带入新增字段
      delete (this.formData.settings.rules as { couponSize?: string }).couponSize;
      (this.formData.settings.multipleDiscountList || []).forEach((item: { couponSize?: string }) => delete item.couponSize);
      (this.formData.settings.discountList || []).forEach((item: { couponSize?: string }) => delete item.couponSize);
    }
    syncExtendedCountdownFontToStyleMap(this.formData.settings);
    // 特定模版需要2张图片
    const popConfig = JSON.parse(JSON.stringify(this.formData));
    if (popConfig && ['35', '49'].includes(`${popConfig.templateId}`)) {
      const settings = popConfig.settings;
      const hasLeftAdImage = !!settings?.typesetting?.leftAdImage;
      const hasRightAdImage = !!settings?.typesetting?.rightAdImage;
      const hasMiddleLeftAdImage = !!settings?.typesetting?.middleLeftAdImage;
      const hasMiddleRightAdImage = !!settings?.typesetting?.middleRightAdImage;
      // 仅允许两张都配置 or 两张都不配置（不允许只配一张）
      if (hasLeftAdImage !== hasRightAdImage || hasMiddleLeftAdImage !== hasMiddleRightAdImage) {
        this.$message({
          message: this.$tx('form.bothAdImagesThisTemplate', '该模版广告图需同时配置2张（不可只配置其中1张）'),
          type: 'error'
        });
        this.repeatSave = false;
        return;
      }
    }

    if (popConfig && (`${popConfig.templateId}` === '36' || `${popConfig.templateId}` === '37' || `${popConfig.templateId}` === '38' || `${popConfig.templateId}` === '39' || `${popConfig.templateId}` === '40' || `${popConfig.templateId}` === '42' || `${popConfig.templateId}` === '43' || `${popConfig.id}` === '1e1609bc024d4517989039886ac7ed34' || `${popConfig.id}` === 'abdac5d809824d8280ffff395a854a15')) {
      const settings = popConfig.settings;
      if (!settings?.typesetting?.imgUrl) {
        this.$message({
          message: this.$tx('form.edit.err.needWheelBg', '请配置转盘底图'),
          type: 'error'
        });
        this.repeatSave = false;
        return;
      }
      if (!settings?.typesetting?.pointImgUrl) {
        this.$message({
          message: this.$tx('form.edit.err.needWheelPointer', '请配置转盘指针图'),
          type: 'error'
        });
        this.repeatSave = false;
        return;
      }
    }

    console.log('校验动态折扣表单')
    if (this.formData.settings.discountList) {
      // 概率不为0的固定折扣码不能为空
      let blocks: Record<string, boolean> = {};
      let errors: Record<string, boolean> = {}
      for (let i = 0; i < this.formData.settings.discountList.length; i++) {
        const item = this.formData.settings.discountList[i];
        let block = this.blockName(i);
        if (item.deg === undefined) {
          blocks[block] = true;
          errors[this.$tx('form.pointerDirection', '指针指向')] = true;
        }
        if (item.rate === undefined) {
          blocks[block] = true;
          errors[this.$tx('form.probability2', '概率')] = true;
        }
        if (item.discountType === 1 && item.rate && item.rate > 0 && !item.coupon) {
          blocks[block] = true;
          errors[this.$tx('brand.monitor.couponCode', '折扣码')] = true;
        }
        if (item.discountType === 2 && !item.discount) {
          blocks[block] = true;
          errors[this.$tx('form.edit.field.uniqueCoupon', '动态折扣码')] = true;
        }
      }
      console.log('校验动态折扣表单: ', blocks, errors);
      if (Object.keys(blocks).length > 0) {
        this.$message.warning(this.$tx('form.edit.err.fillBlocks', '请填写 {{blocks}}的{{fields}}', { blocks: this.enumJoin(Object.keys(blocks)), fields: this.enumJoin(Object.keys(errors)) }));
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelOptionsCollapse;
          wheelNameEl && wheelNameEl.focus();
        })
        return false;
      }

      // 校验折扣码概率相加100
      const totalRate = this.formData.settings.discountList.reduce((a, i) => a += i.rate || 0, 0);
      console.log('校验动态折扣表单 totalRate', totalRate);
      // 使用parseFloat和toFixed解决浮点数精度问题
      if (parseFloat(totalRate.toFixed(2)) !== 100) {
        this.$message.warning(this.$tx('form.edit.err.probSum100', '折扣码概率相加必须等于100'));
        // 如果概率相加不等于100，自动跳转
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelOptionsCollapse;
          wheelNameEl && wheelNameEl.focus();
        })
        return false;
      }
    }

    // 校验所有页面表单不能有重复项
    const pageSettings = this.formData.settings.pageSettings;
    if (pageSettings) {
      const pageSettingsValues = pageSettings.map(item => item.value);
      const uniquePageSettingsValues = [...new Set(pageSettingsValues)];
      if (pageSettingsValues.length !== uniquePageSettingsValues.length) {
        this.$message.warning(this.$tx('form.edit.err.dupAllPages', '所有页面表单不能有重复项'));
        this.repeatSave = false;
        return false;
      }

      // 校验步骤间采集项不能重复
      const attributeSet = new Set<string>();
      const settings = this.formData.settings;
      const allFormList = [
        ...(settings.start || []),
        ...this.customMiddlePages.flatMap((page: string) => ((settings as any)?.[page] || []) as any[]),
        ...(settings.end || [])
      ];
      // 检查是否有重复采集的属性
      for (const field of allFormList) {
        const attribute = field.attribute || field.type || '';
        if (field.type === 'Mobile Number' && (!field.privacyPolicyLink || field.privacyPolicyLink === '')) {
          this.$message.error(this.$tx('form.edit.err.smsPrivacyEmpty', '短信隐私政策链接为空，请完善'));
          this.repeatSave = false;
          return false;
        }
        if (attribute && attribute.trim() !== '') {
          if (attributeSet.has(attribute)) {
            const label = field.label || field.type || attribute;
            this.$message.warning(this.$tx('form.edit.err.dupAttr', '{{label}}属性重复采集', { label }));
            this.repeatSave = false;
            return false;
          }
          attributeSet.add(attribute);
        }
      }

      // 增加pageSetting
      this.formData.settings.pageSettings = this.pageSettings;
      this.formData.settings.rules.stepDisplay = this.customMiddlePages.some(
        (page: string) => (((this.formData.settings as any)?.[page] || []) as any[]).length > 0
      );
    }

    // 校验步骤间采集项不能重复
    const attributeSet = new Set<string>();
    const settings = this.formData.settings;
    const allFormList = [
      ...(settings.start || []),
      ...(settings.middle || []),
      ...(settings.end || [])
    ];
    console.log('allFormList', allFormList);
    // 检查是否有重复采集的属性
    for (const field of allFormList) {
      const attribute = field.attribute || field.type || '';
      if (field.type === 'Mobile Number' && (!field.privacyPolicyLink || field.privacyPolicyLink === '')) {
        this.$message.error(this.$tx('form.edit.err.smsPrivacyEmpty', '短信隐私政策链接为空，请完善'));
        this.repeatSave = false;
        return false;
      }
      if (attribute && attribute.trim() !== '') {
        if (attributeSet.has(attribute)) {
          const label = field.label || field.type || attribute;
          this.$message.warning(this.$tx('form.edit.err.dupAttr', '{{label}}属性重复采集', { label }));
          this.repeatSave = false;
          return false;
        }
        attributeSet.add(attribute);
      }
    }

    // 增加pageSetting
    this.formData.settings.pageSettings = this.pageSettings;
    this.formData.settings.rules.stepDisplay = this.customMiddlePages.some(
      (page: string) => (((this.formData.settings as any)?.[page] || []) as any[]).length > 0
    );

    this.formData.settings.rules.openUrl = this.httpvoid(this.formData.settings.rules.openUrl)
    this.formData.settings.rules.endOpenUrl = this.httpvoid(this.formData.settings.rules.endOpenUrl)
    // console.log(this.formData, 'this.formData');
    this.formData.settings.position.iconShow = Number(this.formData.settings.position.iconShow);
    this.formData.settings.start = this.formattingData(this.formData.settings.start)
    this.customMiddlePages.forEach((page: string) => {
      (this.formData.settings as any)[page] = this.formattingData((this.formData.settings as any)[page] || []);
    });
    window?.gtagNew('event', 'form_tool_enable', {
      event_name: '弹窗_启用订阅工具',
      event_type: '按钮点击',
      Company_id: JSON.parse(localStorage.getItem('companyInfo'))?.id,
      login_id: JSON.parse(localStorage.getItem('displayInfo'))?.id,
      login_type: JSON.parse(localStorage.getItem('displayInfo'))?.innerUserType,
      path_url: window.location.href,
      popId: this.formData?.id,
      templateId: this.formData?.templateId,
      triggerEventType: this.formData?.triggerEventType,
      time: new Date()
    });

    saveDetailPopWindow(this.formData, true).then((res) => {
      const handleAfterPublish = () => {
        store.commit('DELETE_SUGGEST_MAP', 'form_ids');

        if (this.formData.triggerEventType === 7 && !this.formData.id) {
          this.confirmEmbeddedScript(res?.data?.data);
          return
        }

        if (this.formData.triggerEventType === 8 && !this.formData.id) {
          this.confirmCustomTargetScript(res?.data?.data);
          return;
        }

        this.$router.push('/wheel_of_fortune/list');
      };

      if (this.hasSmsSubscriptionEnabled()) {
        this.$alert(
          this.$tx('form.edit.err.smsNoEndPage', '“通过短信订阅”不显示结束页。请手动开启短信欢迎流程，系统将自动发放折扣码（请确保短信欢迎流程配置折扣码）'),
          this.$tx('form.pleaseNote', '请注意'),
          {
            confirmButtonText: this.$tx('form.edit.field.confirm', '确认'),
            showClose: false,
            callback: () => handleAfterPublish()
          }
        );
        return;
      }

      this.$message({
        message: this.$tx('common.success.publish', '发布成功'),
        center: true,
        type: 'success'
      });
      handleAfterPublish();
    }).catch(error => {
      if (isFailMessage(error, '名称不能相同，请修改！')) {
        // 如果名称相同，自动跳转并修改
        this.activePageSetting = 'start';
        this.activeTag = "first";
        this.$nextTick(() => {
          const wheelNameEl: any = this.$refs.styleSetting.$refs.textExhibition.$refs.textStart.$refs.wheelName
          wheelNameEl && wheelNameEl.focus();
        })
      }
      this.repeatSave = false
    });
  }

  /**
   * 提交前兜底补齐 popupLayoutMode，避免在 rules 局部覆盖后丢参：
   * - popWindowWheel=3：强制 fullscreen（若触发类型支持）
   * - 其他：至少保证该字段存在（默认 standard）
   */
  ensurePopupLayoutModeForSubmit() {
    const rules = this.formData?.settings?.rules;
    if (!rules) return;
    const disallowFullscreenForWheel3 = Number(this.formData?.triggerEventType) === 7;
    if (Number(this.formData?.popWindowWheel) === 3 && !disallowFullscreenForWheel3) {
      rules.popupLayoutMode = 'fullscreen';
    } else if (!rules.popupLayoutMode) {
      rules.popupLayoutMode = 'standard';
    }
    normalizePopupLayoutRules(this.formData);
    // 清理全屏快照字段，避免脏数据入库
    const rulesAny: any = rules;
    if (rulesAny._prevFullscreenImgPositions) {
      delete rulesAny._prevFullscreenImgPositions;
    }
    if (rulesAny._prevFullscreenContainerBorderRadius) {
      delete rulesAny._prevFullscreenContainerBorderRadius;
    }
  }

  // @Watch("formData.settings.rules.openUrl")
  // changeOpenUrl(val:string){
  //   console.log(val)
  //   let newStr =val.indexOf("http://")
  //   if (newStr === -1) {
  //     let newStr =val.indexOf("https://")
  //     if (newStr ===-1) {
  //       this.formData.settings.rules.openUrl= 'http://'+ this.formData.settings.rules.openUrl
  //     }
  //   }
  // }

}
